import { MamapediaCategoryItem } from "@/lib/constants";
import Link from "next/link";
import Image from 'next/image';


interface CategoryListItemProps {
  category: MamapediaCategoryItem;
}

const MamapediaDesktopMenuItem = (props: CategoryListItemProps) => {
  const { category } = props;

  return (
    <div className="flex items-center justify-center py-6 hoverable font-poppins">
        <div>
          <Link href={category.url}>
            <p className="text-sm font-medium text-black hover:text-mooimom">
              {category.name}
            </p>
          </Link>
          <div className={`shadow-xl mamapedia-mega-menu`}>
            <div className="container w-full mx-auto">
              <hr className="bg-menuHrBg" />
              <div className="flex items-center justify-around py-6">
                {category.subcategory.map((subItem, index2) => (
                  <div key={index2}>
                    <Link href={subItem.url}>
                      <div className="w-full flex space-x-3 items-center">
                        {subItem.mobile_image !== null && subItem.mobile_image !== undefined && (
                          <Image
                            src={subItem.mobile_image}
                            alt={subItem.name}
                            width={32}
                            height={32}
                            quality={100}
                            className="rounded-full"
                          />
                        )}
                        <p className={`text-black hover:text-mooimom text-sm font-poppins text-center`}>{subItem.name}</p>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default MamapediaDesktopMenuItem
